export const MODULE_TREE = [
  { id: 'PMEMovementDetails', label: 'Movement Details', parent: '' },
  { id: 'PMETransactions', label: 'Transactions', parent: '' },
  { id: 'PMEBinLocations', label: 'Bin Locations', parent: '' },
  { id: 'PMELotDetails', label: 'Lot Details', parent: '' },
  { id: 'PMESerialNumbers', label: 'Serial Numbers', parent: '' },
];
